// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"b795f7c7","85":"00e2de2d","331":"00e2de2d","812":"00e2de2d"}[chunkId] + ".chunk.css";
};